// Import react elements
import { useEffect } from "react";



const PayPalBillingFail = () => {

    // Try to refresh the parent window and close this one
    useEffect(() => {

        // Refresh the parent window if it exists
        if (window.opener && !window.opener.closed) {
            window.opener.location.reload();
        }

        // Try to close this window
        setTimeout(() => {
            window.close();
        }, 500);

    }, []);



    return (

        <div style={{
            minHeight: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "40px",
            textAlign: "center"
        }}>

            <div style={{
                maxWidth: "500px",
                width: "100%",
                padding: "40px",
                borderRadius: "16px",
                background: "#ffffff",
                boxShadow: "0 8px 30px rgba(0,0,0,0.08)"
            }}>

                <h2>Link PayPal Billing</h2>

                <br />

                <p>You can now close the tab</p>

            </div>

        </div>

    );

};

export default PayPalBillingFail;